var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-5 pb-5"},[_c('h5',{staticClass:"c-main__title mb-4"},[_vm._v("List categories")]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('category',{key:category['.key'],attrs:{"categoryName":category.name,"categoryKey":category['.key'],"categoryBackground":category.backgroundName,"categorySlug":category.slug}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38db66e9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Categories.vue
// module id = 75
// module chunks = 0